import React, { useState, useEffect } from 'react';
import AddEditConfigDialog from './addEditCofigDialog/AddEditConfigDialog';
import ConfigSummaryCard from './ConfigSummaryCard';
import { createConfig, getFormattedTransferConfig, getDropdowns, updateConfig, deleteConfig, getConfigs, getFilterReqObj } from './services';
import ALoader from '../../../../views/pages/manage/common/a-loader';
import { successToast } from '../../../../views/pages/manage/common/utils/methods/toasterFunctions/function';
import { fetchBusinessAreasByRegions } from '../../../../views/pages/manage/academicPlanAndTest/constant/common';
import { getDropdownIdsFromSelectArray } from '../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { checkPermission } from '../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import EmprConfigHeaderCard from '../../../../views/pages/manage/masters/studentFinancials/epmrConfigs/EpmrConfigHeader';
import EmptyListPlaceholder from '../../../../views/pages/manage/masters/studentFinancials/epmrConfigs/EmptyListPlaceHolder';
import styles from "./styles.module.scss";
import AFilterForm from '../../../../components/AFilterForm/AFilterForm';
import FunnelIcon from "assets/img/svg/svgComponents/FunnelIcon";
import { getFilterFormFields } from './addEditCofigDialog/utils';
import { getAppliedFilterCount } from '../../components/searchStudent/studentTransfersListing/utils';


const TransferApprovalConfigsListing = ({ userPermissions }) => {

  const isCreatePermission = checkPermission(userPermissions, "C");
  const isUpdatePermission = checkPermission(userPermissions, 'U');
  const isDeletePermission = checkPermission(userPermissions, 'D');

  const [form, setForm] = useState(null);
  const [transferApprovalConfigs, setTransferApprovalConfigs] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buLoading, setBuLoading] = useState(false);
  const [filterForm, setFilterForm] = useState({});


  const handleForm = (key, value) => setForm(prev => ({ ...prev, [key]: value }));

  const addConfigHandler = () => setForm({
    isNew: true,
    approvalSettingDTO: []
  });

  const closeAddEditConfigDialog = () => {
    setForm(null);
    setDropdownData(prev => ({
      ...prev,
      businessAreas: []
    }))
  }

  const addEditConfigDialogOpen = !!form;

  const getAllTransferApprovalConfig = async (dropdowns = dropdownData, filters = filterForm) => {
    try {
      setLoading(true);
      const resp = await getConfigs(getFilterReqObj(filters, dropdowns?.allActiveBu));
      const transferConfigs = resp?.data ?? [];
      setTransferApprovalConfigs(transferConfigs?.map(config => getFormattedTransferConfig(config, dropdowns)))
      setFilterForm(prev => ({
        ...prev,
        appliedFilterCount : getAppliedFilterCount(filters)
      }))
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }


  const init = async () => {
    try {
      setLoading(true);
      const dropdownData = await getDropdowns();
      setDropdownData(dropdownData);
      getAllTransferApprovalConfig(dropdownData)

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }

  }

  const deleteConfigHandler = async (id) => {
    try {
      setLoading(true)
      const resp = await deleteConfig(id);
      if (resp?.code === 200) {
        successToast("Request completed successfully!");
        getAllTransferApprovalConfig();
      }

    } catch (err) {
      console.log(err);

    } finally {
      setLoading(false);
    }
  }

  const createUpdateConfigHandler = async () => {
    try {
      setLoading(true);
      const resp = await (form?.isNew ? createConfig(form) : updateConfig(form));
      if (resp?.code === 200) {
        successToast("Request completed successfully!");
        getAllTransferApprovalConfig();
        closeAddEditConfigDialog();
      }

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  const getBuAgainstRegions = async (regions) => {
    try {
      setBuLoading(true);
      let buAgainstRegions = [];

      if (regions?.length > 0) {
        buAgainstRegions = await fetchBusinessAreasByRegions(getDropdownIdsFromSelectArray(regions));
      }
      return buAgainstRegions;

    } catch (err) {
      console.log(err);
    } finally {
      setBuLoading(false);
    }

  }

  const regionChangeHandler = async (regions) => {
    try {
      handleForm("regions", regions)
      const buAgainstRegions = await getBuAgainstRegions(regions);

      setDropdownData(prev => ({
        ...prev,
        businessAreas: buAgainstRegions
      }))

      //intersection of already selected BUs and the new BU dropdown array
      const filteredBUs = form.businessArea?.filter(el => buAgainstRegions?.some(bu => bu?.value === el?.value));
      handleForm("businessArea", filteredBUs);


    } catch (err) {
      console.error(err);
    }
  }

  const editConfigHandler = async config => {
    try {
      setForm(config);
      const buAgainstRegions = await getBuAgainstRegions(config?.regions);
      setDropdownData(prev => ({
        ...prev,
        businessAreas: buAgainstRegions
      }))
    } catch (err) {
      console.error(err);
    }
  }

  const handleFilterForm = (key, val) => setFilterForm(prev => ({...prev, [key] : val}));

  const removeFilterHandler = async() => {
    await getAllTransferApprovalConfig(dropdownData, {});
    setFilterForm({});
  }

  useEffect(() => {
    init();
  }, [])

  return (
    <>
      {loading && <ALoader position="fixed" />}

      <EmprConfigHeaderCard
        addConfigHandler={addConfigHandler}
        isCreatePermission={isCreatePermission}
        heading='Student Transfer Configs'
        filters={
          <AFilterForm
          btnComponent={<div className={styles['filter-icon-container']}><FunnelIcon/></div>}
          formFields={getFilterFormFields(dropdownData?.allActiveBu)}
          filterForm={filterForm}
          handleFilterForm={handleFilterForm}
          applyFilterHandler={() => getAllTransferApprovalConfig()}
          removeFilterHandler={removeFilterHandler}
          />
        }
      />

      {transferApprovalConfigs?.length != 0
        ? <div className={`p-3 ${styles['config-cards-container']}`}>
          {transferApprovalConfigs?.map(config =>
            <ConfigSummaryCard
              key={config?.id}
              config={config}
              deleteConfigHandler={deleteConfigHandler}
              editConfigHandler={editConfigHandler}
              isUpdatePermission={isUpdatePermission}
              isDeletePermission={isDeletePermission}
            />)}
        </div>
        : <EmptyListPlaceholder
          addConfigHandler={addConfigHandler}
          isCreatePermission={isCreatePermission}
          title='Click here to add first configuration for student transfer'
        />
      }


      <AddEditConfigDialog
        open={addEditConfigDialogOpen}
        handleClose={closeAddEditConfigDialog}
        form={form}
        setForm={setForm}
        handleForm={handleForm}
        dropdownData={dropdownData}
        createUpdateConfigHandler={createUpdateConfigHandler}
        regionChangeHandler={regionChangeHandler}
        buLoading={buLoading}
        loading={loading}
      />

    </>
  );
}

export default TransferApprovalConfigsListing;